export default "__VITE_ASSET__ficlKRnM__"